module.exports = __webpack_public_path__ + "static/img/aboutUs21.be6ac72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs21.jpg
// module id = 1373
// module chunks = 1